import { gql, useMutation } from "@apollo/client";
import {
  UnlinkCbmMemberMutationMutation,
  UnlinkCbmMemberMutationMutationVariables
} from "../../../../../schemaTypes";
import { findCustomerByIdAdminQuery } from "../findCustomerByIdAdmin";

export const unlinkCbmMemberMutation = gql`
  mutation UnlinkCbmMemberMutation($userId: String!) {
    unlinkCbmMember(userId: $userId) {
      errors {
        path
        message
      }
      message
    }
  }
`;

/** Frees the CBM member ID linked to a customer's account (L1/L2 admins). */
export const useUnlinkCbmMember = () => {
  const [mutate, { loading }] = useMutation<
    UnlinkCbmMemberMutationMutation,
    UnlinkCbmMemberMutationMutationVariables
  >(unlinkCbmMemberMutation, { refetchQueries: [findCustomerByIdAdminQuery] });

  const unlink = async (userId: string) => {
    const { data } = await mutate({ variables: { userId } });
    return data?.unlinkCbmMember ?? null;
  };

  return { unlink, loading };
};
